import { Box, Typography } from '@mui/material';
import {
  statusFailedIconSrc,
  statusPendingIconSrc,
  statusSuccessIconSrc,
} from '../../assets/transactions';
import { TRANSACTION_STATUS } from '../../services/transactionService';

const STATUS_CONFIG = {
  [TRANSACTION_STATUS.successful]: {
    label: 'Successful',
    color: '#2ee437',
    icon: statusSuccessIconSrc,
    spritePosition: 'full',
  },
  [TRANSACTION_STATUS.failed]: {
    label: 'Failed',
    color: '#ff3b3b',
    icon: statusFailedIconSrc,
    spritePosition: 'full',
  },
  [TRANSACTION_STATUS.pending]: {
    label: 'Pending',
    color: '#ff7133',
    icon: statusPendingIconSrc,
    spritePosition: 'full',
  },
};

function StatusIcon({ src, spritePosition = 'full' }) {
  const objectPosition =
    spritePosition === 'right'
      ? 'right center'
      : spritePosition === 'left'
        ? 'left center'
        : 'center';

  return (
    <Box
      component="img"
      src={src}
      alt=""
      sx={{
        width: 12,
        height: 12,
        flexShrink: 0,
        display: 'block',
        objectFit: spritePosition === 'full' ? 'contain' : 'cover',
        objectPosition,
      }}
    />
  );
}

/** Figma 11114:38492 / 38507 / pending badge */
export default function TransactionStatusBadge({ status = TRANSACTION_STATUS.successful }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG[TRANSACTION_STATUS.pending];

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 2,
        left: '50%',
        transform: 'translateX(-50%)',
        width: 132,
        height: 29,
        borderRadius: '0 0 16px 16px',
        border: '0.5px solid #6e005a',
        bgcolor: 'rgba(0, 0, 0, 0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.75,
        zIndex: 2,
      }}
    >
      <StatusIcon src={config.icon} spritePosition={config.spritePosition} />
      <Typography
        sx={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 600,
          fontSize: 16,
          lineHeight: '24px',
          letterSpacing: '0.8px',
          color: config.color,
          whiteSpace: 'nowrap',
        }}
      >
        {config.label}
      </Typography>
    </Box>
  );
}
